import View from "./view.js";
import PreviewView from "./previewview.js";
import icons from 'url:../../img/icons.svg';

class BookmarksView extends View {
    _parentElement = document.querySelector(`.bookmarks__list`);
    _errorMessage = `No bookmarks yet, find a recipe and bookmark it 🔖`;
    _message = ``;

    addHnadlerRender(handler) {
        window.addEventListener(`load`, handler);
    };

    _generateMarkup() {
        return this._data
            .map(bookmark => PreviewView.render(bookmark, false))
            .join(``);
    };
};

export default new BookmarksView();